<div class="iframe-container">
  <iframe width = "100%" height="100%" [src] = "base64EncoderUrl"></iframe>
</div>
